export const BubblesMenuItem = (value: string) => {
  const Component = () => (
    <div className="flex items-center justify-center">
      <span
        className="flex border font-bold border-black shadow-none m-0 rounded-full justify-center items-center text-xs p-1"
        style={{ borderWidth: 2, height: 22, width: 22 }}
      >
        {value}
      </span>
    </div>
  )

  Component.displayName = 'BubblesMenuItem'

  return Component
}
